<template>
  <div class="layout-inner">
    <a href="#main-content" class="skip-to-content">Skip to content</a>
    <header>
      <CodementumNavbar />
      <StudioLogo />
      <EventTimer />
    </header>
    <main id="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import EventTimer from '@/components/EventTimer.vue';
import StudioLogo from '@/components/StudioLogo.vue';

export default {
  name: 'app-layout',
  components: {
    StudioLogo,
    EventTimer
  }
};
</script>

<style>
.custom-select {
  height: calc(1.54em + 0.6rem + 0px) !important;
  padding: 0.1rem 2rem 0.1rem 0.7rem !important;
}

.nav-link {
  padding: 0.35rem 1.25rem !important;
}

.nav-tabs > .nav-item {
  background: #3f3f3f;
}

h6 {
  font-weight: 300 !important;
}

.pl-10 {
  padding-left: 10px;
}
</style>
